import React from 'react';
import { AlertTriangle, ArrowRight, GitBranch } from 'lucide-react';
import { LineDiff } from './LineDiff';

export const ReworkPromotePanel = ({ rework }) => {
  if (!rework) return <p className="text-xs text-slate-500">Loading rework details…</p>;
  if (rework.source_missing) {
    return <p className="text-xs text-rose-700" data-testid="rework-source-missing">The source production BOM no longer exists, so this rework can't be promoted.</p>;
  }
  const blocked = rework.open_work_orders.length > 0;
  return (
    <div className="space-y-3" data-testid="rework-promote-panel">
      <div className="rounded border border-fuchsia-200 bg-fuchsia-50/60 p-3 text-sm">
        <div className="flex items-center gap-2 flex-wrap font-mono">
          <GitBranch className="w-4 h-4 text-fuchsia-600" />
          <span>{rework.bom_variant_code}</span>
          <span className="text-slate-500">rev {rework.source_revision}</span>
          <ArrowRight className="w-4 h-4 text-slate-400" />
          <span className="font-semibold text-fuchsia-800" data-testid="rework-target-revision">rev {rework.target_revision}</span>
        </div>
        <p className="text-xs text-slate-600 mt-1">
          Merges into <b>{rework.product_type_name || 'the existing product'}</b> as its next revision, starting as <b data-testid="rework-new-status">{rework.new_status}</b>
          {rework.release_gated && ' (the engineering-match gate requires a matched file before release)'}.
          Rev {rework.source_revision} will be marked <b>Obsolete</b>.
        </p>
      </div>
      {blocked && (
        <div className="rounded border border-rose-200 bg-rose-50 p-3 text-xs text-rose-800 flex gap-2" data-testid="rework-open-wo-warning">
          <AlertTriangle className="w-4 h-4 shrink-0" />
          <div>
            <b>{rework.open_work_orders.length} open work order{rework.open_work_orders.length > 1 ? 's' : ''}</b> still use rev {rework.source_revision}:
            {' '}{rework.open_work_orders.map(w => `${w.work_order_number || w.id.slice(0, 8)} (${w.status})`).join(', ')}.
            Complete or close them before promoting.
          </div>
        </div>
      )}
      <div>
        <p className="text-xs font-medium text-slate-600 mb-1">Changes vs production rev {rework.source_revision}</p>
        <LineDiff diff={rework.diff} testId="rework-diff" />
      </div>
    </div>
  );
};
